import { get } from "./api";
import routes from "./end-points";

export const dashboardApi = {
    init: () => get(routes.dashboard.dashboard),
};
